import AlertTemplate from "react-alert-template-basic";

const options = {
  position: 'bottom right',
  timeout: 2500,
  transition: "fade",
};

export { options, AlertTemplate };
